var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5514 10.6753L26.8285 9.14179C26.278 8.10235 25.1555 7.3653 23.9828 7.27321L11.7261 7.57239C10.8296 7.50199 9.66975 8.14705 9.13134 8.80297C9.04521 8.9079 8.98496 9.03038 8.93492 9.15658L8.13395 11.1762L5.59007 19.5586",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3932 23.4704H32.5298C33.0821 23.4704 33.5298 23.0227 33.5298 22.4704V12.1763C33.5298 11.624 33.0821 11.1763 32.5298 11.1763H8.38281",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707 15.647C23.1453 15.647 20.1188 15.647 20.1188 15.647",
    stroke: "#0E5CF4",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9414 19C24.5345 19 20.1179 19 20.1179 19",
    stroke: "#0E5CF4",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9699,
    cy: 17.3234,
    r: 2.79412,
    fill: "#0E5CF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70703 15.647L17.1883 22.8584L29.8979 23.4296L26.7727 33.1032C26.6016 33.6329 26.0308 33.9209 25.503 33.7438L4.20833 26.5975C3.68892 26.4232 3.40648 25.8634 3.57491 25.342L6.70703 15.647Z",
    stroke: "#20242E",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredMail);
export default __webpack_public_path__ + "static/media/ic-colored-mail.2eae00605b538211b56e9eba8a066e3d.svg";
export { ForwardRef as ReactComponent };